import { Value, Values } from '@lib/interfaces/form';
import _get from 'lodash/get';
import { DocumentationCreateInputObject } from 'graphql-common';
import AssetDocumentFieldNames from '@lib/enums/fieldNames/assetDocumentFieldNames';
import { SelectOption } from '@lib/components/Select/types';
import { prepareAttachedField } from '@lib/utils/prepareAttachedField';

export default function getPreparedCreateFromValues(values: Values) {
  const documents = _get(
    values,
    AssetDocumentFieldNames.Documents,
    [],
  ) as Value[];
  return documents.map((document: any) => {
    const attachmentAttached = prepareAttachedField(
      _get(document, AssetDocumentFieldNames.Document),
      { pickFileFields: true },
    );
    return {
      attachmentAttached,
      documentationTags: _get(document, AssetDocumentFieldNames.Tags).map(
        ({ value }: SelectOption) => ({
          id: value,
        }),
      ),
      name: _get(document, AssetDocumentFieldNames.Name),
    } as DocumentationCreateInputObject;
  });
}
